import { createI18n } from "vue-i18n";
import config from "./config";

const i18n = createI18n(config);

export default i18n;
